import * as React from 'react';

const SvgLinkedin = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M26.156 0H10.156C4.63316 0 0.156006 4.47715 0.156006 10V26C0.156006 31.5228 4.63316 36 10.156 36H26.156C31.6789 36 36.156 31.5228 36.156 26V10C36.156 4.47715 31.6789 0 26.156 0Z"
        fill="url(#paint0_linear_30807_5832)"
      />
      <path
        d="M13.328 26.536H9.289V13.708H13.328V26.536ZM11.306 11.93C10.8478 11.9274 10.4007 11.7892 10.021 11.5327C9.6413 11.2763 9.34609 10.9131 9.17263 10.489C8.99916 10.0649 8.9552 9.59897 9.04631 9.14994C9.13741 8.7009 9.35949 8.28892 9.68452 7.96598C10.0095 7.64304 10.423 7.42362 10.8726 7.33542C11.3222 7.24721 11.7879 7.29417 12.2108 7.47037C12.6338 7.64658 12.995 7.94412 13.249 8.32545C13.503 8.70679 13.6384 9.15482 13.638 9.613C13.6424 9.91975 13.5849 10.2242 13.4691 10.5083C13.3532 10.7924 13.1814 11.0502 12.9637 11.2664C12.7461 11.4827 12.4872 11.6528 12.2024 11.7669C11.9176 11.8809 11.6127 11.9363 11.306 11.93V11.93ZM28.214 26.547H24.177V19.539C24.177 17.472 23.298 16.839 22.164 16.839C21.8216 16.8481 21.4849 16.9288 21.1754 17.0757C20.866 17.2227 20.5908 17.4327 20.3673 17.6923C20.1439 17.9519 19.9772 18.2554 19.8779 18.5832C19.7787 18.9111 19.7491 19.256 19.791 19.596V26.552H15.756V13.717H19.64V15.495H19.692C20.0889 14.8339 20.6524 14.2886 21.326 13.9134C21.9997 13.5382 22.76 13.3464 23.531 13.357C25.784 13.357 28.219 14.694 28.219 18.612L28.214 26.547Z"
        fill="url(#paint1_linear_30807_5832)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_30807_5832"
        x1={11.172}
        y1={-1.54881e-7}
        x2={31.584}
        y2={33.804}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3840FA" />
        <stop offset={1} stopColor="#1F82F6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30807_5832"
        x1={18.6095}
        y1={7.29204}
        x2={30.8314}
        y2={26.5285}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#BFCEFF" />
      </linearGradient>
      <clipPath>
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLinkedin;
